import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import SessionManager from "../../../../utils/sessionManager";
import { showAccessDeniedAlert } from "../../../../utils/accessDenied";
import { showTokenExpiredAlert } from "../../../../utils/alert";

export const activeFarmCrops = createAsyncThunk('activeFarmCrops', async ({ farm_id, status, navigate }) => {

    try {
        const res = await axios({

            method: 'GET',
            url: process.env.REACT_APP_API_URL + 'work-farm-crops/all',
            params: {
                farm_id,
                status: status || 'Active,Inactive,Completed',
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }

        })
        return res
    } catch (error) {
        return error.response
    }
})

const activeFarmCropsSlice = createSlice({
    name: 'activeFarmCrops',
    initialState: {
        data: [],
    },
    reducers: {
        clearActiveFarmCrops: (state) => {
            state.data = [];
        },
    },
    extraReducers: (builder) => {
        builder.addCase(activeFarmCrops.fulfilled, (state, action) => {
            if (action?.payload?.status === 200) {
                const payloadData = action.payload.data.data;
                state.data = payloadData?.rows ?? payloadData ?? [];
            } else if (action?.payload?.status === 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate);
            } else if (action?.payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.data = [];
            }

        });
        builder.addCase(activeFarmCrops.rejected, (state, action) => {
            // console.log('reject', action)
        })
    }
})

export const { clearActiveFarmCrops } = activeFarmCropsSlice.actions;
export default activeFarmCropsSlice.reducer;
